<script>
    import { page } from '$app/stores';
</script>

<svelte:head>
    <title>Alex Brad — Error</title>
    <meta name="description" content="Something went wrong" />
</svelte:head>

<section>
    <div class="section-wrapper">
        <h1>{ $page.status }</h1>
        <p class="body1" style="color: var(--neutral-700)">{ $page.error.message }</p>
        <a href="/"
            class="interactive"
            aria-label="Back to home"
        >
            <svg class="interactive-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.7494 10.5079C19.7494 10.2317 19.5256 10.0079 19.2494 10.0079H7.24944C6.97329 10.0079 6.74944 10.2317 6.74944 10.5079V13.5079C6.74944 13.784 6.97329 14.0079 7.24944 14.0079H19.2494C19.5256 14.0079 19.7494 13.784 19.7494 13.5079V10.5079Z" fill="currentColor"/>
                <path d="M12.4419 3.86141C12.2466 3.66615 11.93 3.66615 11.7347 3.86141L3.95658 11.6396C3.76131 11.8348 3.76131 12.1514 3.95658 12.3467L6.0779 14.468C6.27316 14.6633 6.58974 14.6633 6.785 14.468L14.5632 6.68984C14.7584 6.49458 14.7584 6.17799 14.5632 5.98273L12.4419 3.86141Z" fill="currentColor"/>
                <path d="M3.95651 11.6543C3.76124 11.8496 3.76124 12.1662 3.95651 12.3614L11.7347 20.1396C11.9299 20.3348 12.2465 20.3348 12.4418 20.1396L14.5631 18.0183C14.7584 17.823 14.7584 17.5064 14.5631 17.3112L6.78493 9.53299C6.58967 9.33772 6.27309 9.33772 6.07783 9.53299L3.95651 11.6543Z" fill="currentColor"/>
            </svg>
            <span class="typography">Go back to home</span>
        </a>
    </div>
</section>

<style>
    .section-wrapper {
        height:65vh;
        justify-content: center;
        gap: var(--size-8);
    }

    h1 {
        color: var(--neutral-900);
    }

    a {
		padding: var(--size-7);
		margin: calc(var(--size-7) * -1);
		font-family: Urbanist;
		font-size: var(--size-9);
		font-weight: 600;
		line-height: 130%;
		text-wrap: nowrap;
		border-radius: var(--size-11);
	}

    .interactive {
        color: var(--neutral-900);
    }

    .interactive:hover {
        background-color: var(--neutral-200);
    }

    .interactive:active {
        background-color: var(--neutral-300);
    }

    .interactive-icon {
        width: var(--size-10);
        height: var(--size-10);
    }
</style>